import React from 'react';
import './styles/global.css';

import Topbar     from './components/Topbar';
import Navbar     from './components/Navbar';
import Hero       from './components/Hero';
import Ticker     from './components/Ticker';
import About      from './components/About';
import Principal  from './components/Principal';
import Gallery    from './components/Gallery';
import Facilities from './components/Facilities';
import { History, Motto, Aims } from './components/History';
import Contact    from './components/Contact';
import Footer     from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function App() {
  return (
    <>
      <Topbar />
      <Navbar />
      <Hero />
      <Ticker />
      <About />
      <Principal />
      <Gallery />
      <Facilities />
      <History />
      <Motto />
      <Aims />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </>
  );
}
